import {
    all,
    fork,
    takeEvery,
    call,
    put,
} from 'redux-saga/effects';
import { extractError } from '@/helpers/api';
import DashboardService from '@/services/TourDashboardService';
import { types, actions } from './reducer';

function* getAccommodationCount() {
    try {
        const response = yield call(DashboardService.getAccommodationCount);
        yield put(actions.getAccommodationCountSucceeded(response.data));
    } catch (error) {
        yield put(actions.getAccommodationCountFailed(extractError(error)));
    }
}

function* watchGetAccommodationCount() {
    yield takeEvery(
        types.REQUEST_GET_ACCOMMODATION_COUNT,
        getAccommodationCount,
    );
}

function* accommodationDashboardSaga() {
    yield all([
        fork(watchGetAccommodationCount),
    ]);
}

export default accommodationDashboardSaga;
